export interface MowerOption {
  type: string
  size: string
  avgMowingTime: string
  suitability: 'Ideal' | 'Suitable' | 'Too Small' | 'Too Large'
  priceRange: string
}

export interface MowerRecommendation {
  sizeRange: [number, number]
  recommended: string
  options: MowerOption[]
}

export interface SpreaderRecommendation {
  sizeRange: [number, number]
  type: string
  capacity: string
  refillsNeeded: number
  priceRange: string
}

export const MOWER_RECOMMENDATIONS: MowerRecommendation[] = [
  {
    sizeRange: [0, 5000],
    recommended: '20-21 inch push or self-propelled mower',
    options: [
      {
        type: 'Reel Mower',
        size: '16-18 inches',
        avgMowingTime: '30 minutes',
        suitability: 'Suitable',
        priceRange: '$80-$200'
      },
      {
        type: 'Push Mower',
        size: '20-21 inches',
        avgMowingTime: '20 minutes',
        suitability: 'Ideal',
        priceRange: '$200-$500'
      },
      {
        type: 'Self-Propelled',
        size: '21 inches',
        avgMowingTime: '15 minutes',
        suitability: 'Ideal',
        priceRange: '$300-$700'
      }
    ]
  },
  {
    sizeRange: [5000, 10000],
    recommended: '21 inch self-propelled mower',
    options: [
      {
        type: 'Push Mower',
        size: '21 inches',
        avgMowingTime: '60 minutes',
        suitability: 'Suitable',
        priceRange: '$200-$500'
      },
      {
        type: 'Self-Propelled Mower',
        size: '21 inches',
        avgMowingTime: '40 minutes',
        suitability: 'Ideal',
        priceRange: '$350-$800'
      },
      {
        type: 'Riding Mower',
        size: '30 inches',
        avgMowingTime: '25 minutes',
        suitability: 'Suitable',
        priceRange: '$1,500-$2,500'
      }
    ]
  },
  {
    sizeRange: [10000, Infinity],
    recommended: '42-54 inch riding or zero-turn',
    options: [
      {
        type: 'Riding Mower',
        size: '30 inches',
        avgMowingTime: '45 minutes',
        suitability: 'Suitable',
        priceRange: '$1,500-$2,500'
      },
      {
        type: 'Riding Mower',
        size: '42 inches',
        avgMowingTime: '30 minutes',
        suitability: 'Ideal',
        priceRange: '$2,000-$3,500'
      },
      {
        type: 'Zero-Turn Mower',
        size: '54 inches',
        avgMowingTime: '20 minutes',
        suitability: 'Ideal',
        priceRange: '$3,000-$5,000'
      }
    ]
  }
]

export const SPREADER_RECOMMENDATIONS: SpreaderRecommendation[] = [
  {
    sizeRange: [0, 5000],
    type: 'Broadcast Spreader',
    capacity: '10-15 pounds',
    refillsNeeded: 0,
    priceRange: '$30-$80'
  },
  {
    sizeRange: [5000, 15000],
    type: 'Broadcast Spreader',
    capacity: '18-25 pounds',
    refillsNeeded: 1,
    priceRange: '$60-$150'
  },
  {
    sizeRange: [15000, Infinity],
    type: 'Tow-Behind Spreader',
    capacity: '40+ pounds',
    refillsNeeded: 2,
    priceRange: '$120-$300'
  }
]

export function getMowerRecommendation(sqFt: number): MowerRecommendation {
  const recommendation = MOWER_RECOMMENDATIONS.find(
    rec => sqFt >= rec.sizeRange[0] && sqFt < rec.sizeRange[1]
  )
  return recommendation || MOWER_RECOMMENDATIONS[MOWER_RECOMMENDATIONS.length - 1]
}

export function getSpreaderRecommendation(sqFt: number): SpreaderRecommendation {
  const recommendation = SPREADER_RECOMMENDATIONS.find(
    rec => sqFt >= rec.sizeRange[0] && sqFt < rec.sizeRange[1]
  )
  return recommendation || SPREADER_RECOMMENDATIONS[SPREADER_RECOMMENDATIONS.length - 1]
}
